import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { BsFillTrashFill, BsPencilSquare } from "react-icons/bs"
import useFaqList from "./useFaqList"
import DeleteModal from "../../../components/modal/DeleteModal"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const FaqList = () => {
    const {
        faqs,
        getFaqList,
        deleteFaq,
    } = useFaqList()

    const navigate = useNavigate()

    useEffect(() => {
        getFaqList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteID, setDeleteID] = useState();
    const [userName, setName] = useState();

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        List of FAQ
                    </h5>
                    <ActionButtonGradient
                        onClick={() => navigate("/faq/form")}
                        variant="success"
                        children={"Create FAQ"}
                    />
                </div>

                <div className="table-responsive">
                    <table className="table align-items-center">
                        <thead>
                            <tr style={{ backgroundColor: '#f8f9fa' }}>
                                <th className="text-center" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px',
                                    width: '35%',
                                }}>Title</th>
                                <th className="text-center" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}>Answer</th>
                                <th className="text-center" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}>Order</th>
                                <th className="text-center" style={{ 
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}>Status</th>
                                <th className="text-center" style={{
                                    width: '5%',
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}></th>
                                <th className="text-center" style={{
                                    width: '5%',
                                    fontWeight: 600, 
                                    color: '#495057', 
                                    padding: '12px',
                                    fontSize: '14px'
                                }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                faqs.map((data) => (  
                                    <tr key={data.ID}>
                                        <td className="" style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px'
                                        }}>{data.Title}</td>
                                        <td className="" style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px'
                                        }}>{data.Answer}</td>
                                        <td className="text-center" style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px'
                                        }}>{data.Order}</td>
                                        <td className="text-center" style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px'
                                        }}>{data.Active ? "Active" : "Not Active"}</td>
                                        <td className="text-center">
                                            <button 
                                                onClick={() => navigate(`/faq/form/${data.ID}`)}    
                                                title="Edit FAQ"
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #02B4CC',
                                                    backgroundColor: 'transparent',
                                                    color: '#02B4CC',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#02B4CC';
                                                    e.currentTarget.style.color = 'white';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                    e.currentTarget.style.color = '#02B4CC';
                                                }}
                                            >
                                                <BsPencilSquare size={14}/>
                                            </button>
                                        </td>
                                        <td className="text-center">
                                            <button 
                                                onClick={() => {
                                                    handleShow()
                                                    setDeleteID(data.ID)
                                                    setName(data.Title)
                                                }}   
                                                title="Delete FAQ"
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #dc3545',
                                                    backgroundColor: 'transparent',
                                                    color: '#dc3545',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#dc3545';
                                                    e.currentTarget.style.color = 'white';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                    e.currentTarget.style.color = '#dc3545';
                                                }}
                                            >
                                                <BsFillTrashFill size={14}/>
                                            </button>
                                        </td>
                                    </tr>    
                                ))
                            }     
                        </tbody>
                    </table>
                </div>
            </div>
            
            <DeleteModal 
                show={show} 
                handleClose={handleClose} 
                handleOk={async () => {
                    await deleteFaq(deleteID, () => getFaqList())
                    handleClose()
                }} 
                title={userName}
            />
        </div>
    )
}

export default FaqList